import { createAction } from "@reduxjs/toolkit";
import { action } from "../../actions";
export const publishStreamRequest = createAction(action("PUBLISH_STREAM_REQUEST"));
export const publishStreamSuccess = createAction(action("PUBLISH_STREAM_SUCCESS"));
export const publishStreamFailure = createAction(action("PUBLISH_STREAM_FAILURE"));
export const unpublishStreamRequest = createAction(action("UNPUBLISH_STREAM_REQUEST"));
export const unpublishStreamSuccess = createAction(action("UNPUBLISH_STREAM_SUCCESS"));
export const unpublishStreamFailure = createAction(action("UNPUBLISH_STREAM_FAILURE"));
export const publishStreamIceCandidate = createAction(action("PUBLISH_STREAM_ICE_CANDIDATE"));
export const publishStreamIceStateChange = createAction(action("PUBLISH_STREAM_ICE_STATE_CHANGE"));
export const publishStreamConnectionStateChange = createAction(action("PUBLISH_STREAM_CONNECTION_STATE_CHANGE"));
export const publishState = createAction(action("PUBLISH_STATE"));
